import { render, staticRenderFns } from "./DownloadsLinks.vue?vue&type=template&id=580d32de&scoped=true"
import script from "./DownloadsLinks.vue?vue&type=script&lang=js"
export * from "./DownloadsLinks.vue?vue&type=script&lang=js"
import style0 from "./DownloadsLinks.vue?vue&type=style&index=0&id=580d32de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d32de",
  null
  
)

export default component.exports